import { useMutation } from "@tanstack/react-query";

import { ApiError } from "@shared/types";
import { FolderGenerationResult } from "@modules/folderGenerator/types";
import { FolderGeneratorFormValues } from "@modules/folderGenerator/validations";

import { generateFolderService } from "./service";
import { UseGenerateFolderMutationOptions } from "./types";

export function useGenerateFolderMutation(
  options?: UseGenerateFolderMutationOptions
) {
  return useMutation<FolderGenerationResult, ApiError, FolderGeneratorFormValues>({
    mutationFn: generateFolderService,
    ...options,
  });
}
